var map = {
	"./1-3.jpg": 4883,
	"./2-1.jpg": 2974,
	"./3.jpg": 6125,
	"./4.jpg": 9254,
	"./5.jpg": 867,
	"./6.jpg": 820,
	"./7.jpg": 8865,
	"./8.jpg": 1514,
	"./CRE-program-conducted-by-VSS-2025-2.jpg": 1927,
	"./CRE-program-conducted-by-VSS-2025-3.jpg": 762,
	"./CRE-program-conducted-by-VSS-2025-5.jpg": 1964,
	"./CRE-program-conducted-by-VSS-2025-6.jpg": 2587,
	"./CRE-program-conducted-by-VSS-2025-7.jpg": 7630,
	"./CRE-program-conducted-by-VSS-2025.jpg": 1842,
	"./Medical-Health-Check-up.jpg": 1837,
	"./Picnic-2.jpg": 7555,
	"./Picnic-3.jpg": 5382,
	"./Picnic-4.jpg": 6829,
	"./Picnic-5.jpg": 5904,
	"./Picnic.jpg": 2614,
	"./Psychological-Assessment.jpg": 1496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 607;